import { render } from "./UIUCHeader.vue?vue&type=template&id=9040e5b2&scoped=true"
import script from "./UIUCHeader.vue?vue&type=script&lang=js"
export * from "./UIUCHeader.vue?vue&type=script&lang=js"

import "./UIUCHeader.vue?vue&type=style&index=0&id=9040e5b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9040e5b2"]])

export default __exports__